import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

class WebNotificationManagementAPI implements IAPI {
  prefix = '/WebNotificationManagement'

  fetchList (params: TWebNotificationManagementAPI.Params.FetchList) {
    const url = appendParams(`${this.prefix}/Get`, { ...params })
    return API.get<TWebNotificationManagement.TState['notificationList']>(url)
  }

  async publishNotification (data: any) {
    const response = await API.post<TWebNotificationManagement.TState['notificationDetail']>(`${this.prefix}/Add`, data)
    return response.data
  }

  fetchSingle (id: string) {
    return API.get<TWebNotificationManagement.TState['notificationDetail']>(`${this.prefix}/GetById?id=${id}`)
  }

  async updateNotification (data: any) {
    const response = await API.put<TWebNotificationManagement.TState['notificationDetail']>(`${this.prefix}/Update`, data)
    return response.data
  }
}

export const webNotificationManagementAPI = new WebNotificationManagementAPI()
